import { DashboardService } from '../../../../../service/events/dashboard.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { FertirrigacionFormDefinition } from './form-control/form-definition';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import {
  build,
  pool,
} from '../../../../../common/classes/request-builder';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { HttpClient } from '@angular/common/http';

import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { FertirrigacionModel } from 'src/app/models/tareas/fertirrigacion.model';
import { AnalisisApiService } from 'src/app/service/api/analisis-api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { StorageManager } from 'src/app/common/storage-manager.class';
@Component({
  selector: 'app-fertirrigacion-form',
  standalone: false,
  templateUrl: './fertirrigacion-form.component.html',
  styleUrls: ['./fertirrigacion-form.component.scss'],
})
export class FertirrigacionFormComponent
  extends BaseForm<FertirrigacionModel>
  implements OnInit, OnDestroy {
  public loadingData = true;

  public comunidadForm: FormGroup;

  public form!: FertirrigacionFormDefinition;

  public formRequest: ReactiveFormRequestCoordinator<FertirrigacionModel>;

  public getRequest = this.tareasApi.fertirrigacion.GET;

  constructor(
    public fincasApi: FincasApiService,
    public siexApi: SiexApiService,
    public tareasApi: TareasApiService,
    public productosApi: ProductosApiService,
    public trabajadoresApi: TrabajadoresApiService,
    public override router: Router,
    public override route: ActivatedRoute,
    public dashboardEvents: DashboardService,
    public clientesApi: ClientesApiService,
    public analisisApi: AnalisisApiService,
    private readonly http: HttpClient,
    private readonly formBuilder: FormBuilder
  ) {
    super(
      route,
      router,
      dashboardEvents,
      tareasApi.fertirrigacion.PUT,
      tareasApi.fertirrigacion.POST,
      'fertirrigacion',
      'Editar Riego',
      'Realizar Riego',
      'Duplicar Riego'
    );
    this.formRequest = new ReactiveFormRequestCoordinator<FertirrigacionModel>;

    this.comunidadForm = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      id_usuario: [StorageManager.getUser().id],
      id_cliente: [StorageManager.getClient()?.id ?? ''],
    });
  }

  public ngOnInit(): void {
    this.resetExternalDropdowns();
    this.form = new FertirrigacionFormDefinition(this.getType(), this.getModel() as Record<string, string>, null);
    
    this.initFormData();
    this.formRequest.executePhase(FormPhase.LOAD);
    this.softInit(this.getType());
    this.form.requestType = this.getType();
  }

  public saveNewOption(): void {
    if (this.comunidadForm.invalid) {
      this.comunidadForm.markAllAsTouched();
      return;
    }

    const endpoint: string = `${this.form.env.serverUrl}/ws/index.php?p1=generic&p2=comunidades_regantes`;
    const payload: ComunidadesRegantesModel = this.comunidadForm.getRawValue();

    this.http.post<ComunidadesRegantesModel>(endpoint, payload)
      .subscribe({
        next: () => {
          this.comunidadForm.reset({
            nombre: '',
            id_usuario: StorageManager.getUser().id,
            id_cliente: StorageManager.getClient()?.id ?? '',
          });

          this.form.openDialog = false;

          pool([
            build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
          ], () => {}).then(() => {
            const newName = payload.nombre;
            const match = this.form.lists.comunidadesRegantes.filtered
              .find((item: any) => item.value && item.value.nombre === newName);

            if (match) {
              const control = this.formBuilderRef?.model?.get('id_comunidad_regantes');

              if (control) {
                control.patchValue(match.value?.id, { emitEvent: false });
                control.markAsPristine();
              }
            }

            this.dropdownLoadTrigger.next();
          });
        },
        error: (error: unknown) => {
          console.error('Error creating comunidad_regantes:', error);
        },
      });
  }

  formChanges(formModel: [object, string], tag: string): void {
    this.form.model = formModel as unknown as FertirrigacionModel;
    this.form.tag = tag;
  }

  private initFormData(): Promise<unknown> {
    const buildsRequest = [
      build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
      build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
      build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
      build(
        this.fincasApi.parcelasGET,
        this.form.lists.parcelas,
        this.form.env.appName === 'avafitogest' ? this.parcelaLabel : 'nombre',
        true
      ),
      build(this.siexApi.cultivosGET, this.form.lists.cultivos, 'cultivo', true),
      build(this.siexApi.sistemasRiegoGET, this.form.lists.sistemasRiego, 'sistema_de_riego'),
      build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
      build(
        this.trabajadoresApi.maquinariaGET,
        this.form.lists.maquinarias,
        'nombre'
      ),
    ];

    return pool(buildsRequest, () => {
      this.formRequest.executePhase(FormPhase.UPDATE);
    }).then(() => {
      this.finalizeExternalDropdowns();
      this.dropdownLoadTrigger.next();
      this.loadingData = false;
      return;
    })
      .catch((e) => {
        console.log('catch en pool: ' + e);
      });
  }


  private readonly parcelaLabel = (p: ParcelasModel): string => {
    const nombre = (p.nombre ?? '').toString().trim();
    const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

    let zonaRiegoAbrev = '';

    if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
      const zr = (p.zona_riego ?? '').toString().toLowerCase();

      if (zr.includes('alta')) { zonaRiegoAbrev = 'ZA'; }
      else if (zr.includes('baja')) { zonaRiegoAbrev = 'ZB'; }
    }

    const variedadConZona = zonaRiegoAbrev
      ? `${variedad} - ${zonaRiegoAbrev}`
      : variedad;

    const pol = (p.poligono ?? '').toString().trim();
    const num = (p.numero ?? '').toString().trim();
    const rec = (p.recinto ?? '').toString().trim();
    const codigos = [pol, num, rec].filter(Boolean).join('-');

    const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
    const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
    const supFmt = supNum.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const uds = this.form.env.textoSuperficie || 'ha';

    const derecha = [
      codigos || undefined,
      `${supFmt} ${uds}`
    ].filter(Boolean).join(' · ');

    return `${nombre} - ${variedadConZona} — ${derecha}`;
  };
}
